import type { ReactNode } from "react";
import { RiskBadge, type Risk } from "./risk-badge.tsx";

export interface TimelineItem {
  readonly version: number;
  readonly title: string;
  readonly risk: Risk;
  readonly createdAt: string;
  readonly createdAtText: string;
  readonly current: boolean;
  readonly currentLabel: string;
  readonly actions?: ReactNode;
}

/** Lịch sử phiên bản: danh sách có thời gian máy đọc được (`<time dateTime>`). */
export function VersionTimeline({ items, riskLabel, title }: { items: readonly TimelineItem[]; riskLabel: (r: Risk) => string; title: string }) {
  return (
    <ol aria-label={title} className="relative space-y-3 border-l border-(--saa-border) pl-4">
      {items.map((v) => (
        <li key={v.version} className="flex flex-wrap items-center justify-between gap-2">
          <div className="flex flex-col">
            <span className="text-sm font-medium">
              {v.title}
              {v.current ? <span className="ml-2 rounded bg-(--saa-muted) px-1.5 py-0.5 text-xs">{v.currentLabel}</span> : null}
            </span>
            <time dateTime={v.createdAt} className="text-xs text-(--saa-fg-muted)">
              {v.createdAtText}
            </time>
          </div>
          <div className="flex items-center gap-2">
            <RiskBadge risk={v.risk} label={riskLabel(v.risk)} />
            {v.actions}
          </div>
        </li>
      ))}
    </ol>
  );
}
